export function getPageOffset(limit: number, page?: number | string) {
  const maxPage = 10000 / limit;

  return Number(page) > 0 ? ((Number(page) > maxPage ? maxPage : Number(page)) - 1) * limit : 0;
}
